package settings.diagnosisSetting.components

import antd.badge.badge
import antd.button.button
import antd.card.card
import antd.descriptions.descriptions
import antd.descriptions.descriptionsItem
import antd.layout.space
import antd.message.message
import antd.tabs.tabPane
import antd.tabs.tabs
import antd.tag.tag
import com.jingfangpai.api.clients.SignSymptomSettingApiClient
import com.jingfangpai.common.data.type.DateTime
import com.jingfangpai.common.orm.mapping.DiagnosisSetting
import com.jingfangpai.common.orm.mapping.SignSymptomSetting
import com.jingfangpai.common.orm.mapping.enums.DiagnosisSettingPersonType
import com.jingfangpai.diagnosisSetting.model.DiagnosisSettings
import kotlinext.js.js
import react.*
import react.dom.*
import settings.diagnosisSetting.containers.DiagnosisSettingPageContext

external interface DiagnosisSettingProps : RProps {
    var currentUserId:String
}

data class DiagnosisSettingContextData(var placeHolderFunction: (param: String) -> Unit)

val DiagnosisSettingComponent = functionalComponent<DiagnosisSettingProps> { props ->

    val ctx = useContext(DiagnosisSettingPageContext)
    val (editDiagnosisSettingSettingModalVisibility,setEditDiagnosisSettingSettingModalVisibility) = useState(false)
    val (editSignSymptomModalVisibility,setEditSignSymptomModalVisibility) = useState(false)
    val (DiagnosisSettings,setDiagnosisSettings) = useState(DiagnosisSettings())
    val (editingSetting,setEditingSetting) = useState(DiagnosisSetting().apply {
        createdBy = props.currentUserId
    })
    val (editingSignSymptomName,setEditingSignSymptomName) = useState("")
    val (editingSignSymptomSetting,setEditingSignSymptomSetting) = useState(SignSymptomSetting().apply {
        createdBy = props.currentUserId
    })
    //val (signSymptomOptions,setSignSymptomOptions) = useState(arrayOf<CascadedOption<String>>())

    fun loadDiagnosisSettings(){
        if(!props.currentUserId.isNullOrBlank()) {
            ctx.getCurrentUserAvailable(props.currentUserId, { resp->
                 if(resp.ok()){
                     resp.data?.let { setDiagnosisSettings(it) }
                 }else{
                     message.error("加载诊查设置出错：${resp.message}")
                 }
            }, {
                message.error("加载诊查设置出错：${it.message}")
            })
        }
    }

    /**fun loadSignSymptomOptions(){
        ctx.getSignSymptomOptions({ resp->
            if(resp.ok()){
                resp.data?.let { setSignSymptomOptions(it) }
            }else{
                message.error("获取体征症状列表失败:${resp.message}")
            }
        },{
            message.error("获取体征症状列表失败:${it.message}")
        })
    }*/

    useEffectOnce {
        loadDiagnosisSettings()
        //loadSignSymptomOptions()
    }

    div("diagnosisSetting") {
        card {
            attrs{
                title = buildElement {
                    div{
                        +"诊查设置"
                        if(DiagnosisSettings.system.isEmpty() && DiagnosisSettings.organization.isEmpty() && DiagnosisSettings.personal.isEmpty()){
                            tag{
                                +"暂无设置"
                            }
                        }else{
                            tag{
                                +"共定义了${DiagnosisSettings.system.size+DiagnosisSettings.organization.size+DiagnosisSettings.personal.size}个设置"
                            }
                        }
                    }
                }
                extra = buildElement {
                    button {
                        attrs{
                            onClick = {
                                setEditingSetting(DiagnosisSetting().apply {
                                    createdBy = props.currentUserId
                                })
                                setEditDiagnosisSettingSettingModalVisibility(true)
                            }
                        }
                        +"增加设置"
                    }
                    /*button {
                        attrs{
                            onClick = {setEditModalVisibility(true)}
                        }
                        +"增加症状设置"
                    }*/
                }
            }
            div{
                this.attrs{
                    jsStyle = js{
                        padding = "20px"
                        background = "#fefefe"
                    }
                }
                if(DiagnosisSettings.system.size>0){
                    tabs {
                        attrs{
                            style = js{
                                margin = "0px"
                            }
                            type = "card"
                        }
                        tabPane {
                            attrs{
                                tab = "系统默认"
                                key = "1"
                            }
                            DiagnosisSettings.system.forEachIndexed { index, diagnosisSetting ->
                                card {
                                    attrs{
                                        title= buildElement{
                                            space {
                                                tag{
                                                    attrs{
                                                        color = "#2db7f5"
                                                    }
                                                    +"${diagnosisSetting.name?:""}"
                                                }
                                                button {
                                                    attrs{
                                                        type = "link"
                                                    }
                                                    +"编辑"
                                                }
                                            }
                                        }
                                        extra = buildElement {
                                            button {
                                                attrs{
                                                    type = "default"
                                                    onClick = {
                                                        setEditingSignSymptomSetting(SignSymptomSetting().apply{
                                                            diagnosisSettingId = diagnosisSetting.id
                                                            createdBy = props.currentUserId
                                                            createdOn = DateTime()
                                                        })
                                                        setEditSignSymptomModalVisibility(true)
                                                    }
                                                }
                                                +"添加症状"
                                            }
                                        }
                                    }
                                    descriptions {
                                        attrs{
                                            //title = "设置详情"
                                        }
                                        /*descriptionsItem {
                                            attrs{
                                                label = "设置类型"
                                            }
                                            +"${diagnosisSetting.type}"
                                        }*/
                                        descriptionsItem {
                                            attrs{
                                                label = "适用性别"
                                            }
                                            +"${diagnosisSetting.sex?.toString()}"
                                        }
                                        descriptionsItem {
                                            attrs{
                                                label = "适用人群"
                                            }
                                            +DiagnosisSettingPersonType.values().filter { it == DiagnosisSettingPersonType.不限 }.toString()?:""
                                            //+"${diagnosisSetting.personType?.toString()}"
                                        }
                                        descriptionsItem {
                                            attrs{
                                                label = "适用年龄"
                                            }
                                            +"不限"
                                        }
                                        descriptionsItem {
                                            attrs{
                                                label = "适用BMI范围"
                                            }
                                            +"不限"
                                        }
                                    }
                                    diagnosisSetting.signSymptomSettings.forEachIndexed { symptomIndex, signSymptomSettingDto ->
                                        card {
                                            attrs{
                                                type = "inner"
                                                title = buildElement{
                                                    span{
                                                        badge{
                                                            attrs{
                                                                count = "${symptomIndex+1}"
                                                            }
                                                        }
                                                        +"${signSymptomSettingDto.signSymptomName?:""}"
                                                    }

                                                }
                                                extra = buildElement{
                                                    button {
                                                        attrs{

                                                        }
                                                        +"编辑"
                                                    }
                                                }
                                            }
                                            descriptions {
                                                descriptionsItem {
                                                    attrs{
                                                        label = "仅供医生使用"
                                                    }
                                                    +"${if(true == signSymptomSettingDto.isDoctorOnly) "是" else "否"}"
                                                }
                                                descriptionsItem {
                                                    attrs{
                                                        label = "代表存在的问题"
                                                    }
                                                    +"${signSymptomSettingDto.questionForYes?:""}"
                                                }
                                                descriptionsItem {
                                                    attrs{
                                                        label = "代表不存在的问题"
                                                    }
                                                    +"${signSymptomSettingDto.questionForNo?:""}"
                                                }
                                                descriptionsItem {
                                                    attrs{
                                                        label = "代表程度轻的问题"
                                                    }
                                                    +"${signSymptomSettingDto.questionForMild?:""}"
                                                }
                                                descriptionsItem {
                                                    attrs{
                                                        label = "代表中等程度的问题"
                                                    }
                                                    +"${signSymptomSettingDto.questionForModerate?:""}"
                                                }
                                                descriptionsItem {
                                                    attrs{
                                                        label = "代表严重的问题"
                                                    }
                                                    +"${signSymptomSettingDto.questionForSerious?:""}"
                                                }
                                            }
                                        }
                                    }

                                }
                            }
                        }
                    }
                }
            }
        }
        child(DiagnosisSettingModal){
            attrs{
                visibility = editDiagnosisSettingSettingModalVisibility
                updateVisibility = {setEditDiagnosisSettingSettingModalVisibility(it)}
                currentSetting = editingSetting
                saveSetting = ctx.saveDiagnosisSetting
                onSaved = {savedForm:DiagnosisSetting ->
                    setEditingSetting(savedForm);
                    loadDiagnosisSettings();
                }
            }
        }
        child(SignSymptomSettingModal){
            attrs{
                visibility = editSignSymptomModalVisibility
                updateVisibility = {setEditSignSymptomModalVisibility(it)}
                currentSetting = editingSignSymptomSetting
                getAvailableSignSymptoms = SignSymptomSettingApiClient::getAvailableOptions
                saveSetting = SignSymptomSettingApiClient::save
                onSaved = {saved:SignSymptomSetting ->
                    setEditingSignSymptomSetting(saved);
                    loadDiagnosisSettings();
                }
                currentSignSymptomName = editingSignSymptomName
            }
        }
    }
}
